// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/dashboard_service.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContentGrantList, ContentSharing, ContentVisibility } from "../../artifacts/v1/contentgrant_pb";
import { file_chalk_artifacts_v1_contentgrant } from "../../artifacts/v1/contentgrant_pb";
import type { Dashboard, DashboardWidget } from "../../artifacts/v1/dashboard_pb";
import { file_chalk_artifacts_v1_dashboard } from "../../artifacts/v1/dashboard_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/dashboard_service.proto.
 */
export const file_chalk_server_v1_dashboard_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_artifacts_v1_contentgrant, file_chalk_artifacts_v1_dashboard, file_chalk_auth_v1_permissions, file_google_protobuf_field_mask]);

/**
 * Dashboard-wide view controls. Server-owned and UI-set, kept separate from the dashboard artifact:
 * `chalk apply` reconciles the artifact (name + widgets) and must never touch these, so they
 * cannot live inside the artifact. The saved defaults only; the active viewing state is carried in
 * the URL on the frontend and is not persisted here.
 *
 * @generated from message chalk.server.v1.DashboardControls
 */
export type DashboardControls = Message<"chalk.server.v1.DashboardControls"> & {
  /**
   * Default time-range preset id (matches the frontend's DateRangePreset ids, e.g. "24h").
   *
   * @generated from field: string default_range_preset_id = 1;
   */
  defaultRangePresetId: string;

  /**
   * Which chart annotations to show; an annotation is shown iff it appears here.
   *
   * @generated from field: repeated chalk.server.v1.DashboardAnnotation annotations = 2;
   */
  annotations: DashboardAnnotation[];
};

/**
 * Describes the message chalk.server.v1.DashboardControls.
 * Use `create(DashboardControlsSchema)` to create a new message.
 */
export const DashboardControlsSchema: GenMessage<DashboardControls> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 0);

/**
 * @generated from message chalk.server.v1.CreateDashboardRequest
 */
export type CreateDashboardRequest = Message<"chalk.server.v1.CreateDashboardRequest"> & {
  /**
   * Only `name` and `widgets` on the artifact are read; OUTPUT_ONLY fields are server-populated.
   *
   * @generated from field: chalk.artifacts.v1.Dashboard dashboard = 1;
   */
  dashboard?: Dashboard;

  /**
   * Optional initial view controls; omit to create the dashboard without any.
   *
   * @generated from field: optional chalk.server.v1.DashboardControls controls = 2;
   */
  controls?: DashboardControls;

  /**
   * Omit for environment-visible. RESTRICTED requires a user agent, to have an owner.
   *
   * @generated from field: optional chalk.artifacts.v1.ContentSharing sharing = 3;
   */
  sharing?: ContentSharing;
};

/**
 * Describes the message chalk.server.v1.CreateDashboardRequest.
 * Use `create(CreateDashboardRequestSchema)` to create a new message.
 */
export const CreateDashboardRequestSchema: GenMessage<CreateDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 1);

/**
 * @generated from message chalk.server.v1.CreateDashboardResponse
 */
export type CreateDashboardResponse = Message<"chalk.server.v1.CreateDashboardResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.Dashboard dashboard = 1;
   */
  dashboard?: Dashboard;

  /**
   * @generated from field: chalk.server.v1.DashboardControls controls = 2;
   */
  controls?: DashboardControls;

  /**
   * @generated from field: chalk.artifacts.v1.ContentSharing sharing = 3;
   */
  sharing?: ContentSharing;
};

/**
 * Describes the message chalk.server.v1.CreateDashboardResponse.
 * Use `create(CreateDashboardResponseSchema)` to create a new message.
 */
export const CreateDashboardResponseSchema: GenMessage<CreateDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 2);

/**
 * @generated from message chalk.server.v1.GetDashboardRequest
 */
export type GetDashboardRequest = Message<"chalk.server.v1.GetDashboardRequest"> & {
  /**
   * @generated from field: string dashboard_id = 1;
   */
  dashboardId: string;

  /**
   * @generated from field: optional google.protobuf.FieldMask read_mask = 2;
   */
  readMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.GetDashboardRequest.
 * Use `create(GetDashboardRequestSchema)` to create a new message.
 */
export const GetDashboardRequestSchema: GenMessage<GetDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 3);

/**
 * @generated from message chalk.server.v1.GetDashboardResponse
 */
export type GetDashboardResponse = Message<"chalk.server.v1.GetDashboardResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.Dashboard dashboard = 1;
   */
  dashboard?: Dashboard;

  /**
   * @generated from field: chalk.server.v1.DashboardControls controls = 2;
   */
  controls?: DashboardControls;

  /**
   * Readable by anyone who can read the dashboard; changing it requires OWNER.
   *
   * @generated from field: chalk.artifacts.v1.ContentSharing sharing = 3;
   */
  sharing?: ContentSharing;
};

/**
 * Describes the message chalk.server.v1.GetDashboardResponse.
 * Use `create(GetDashboardResponseSchema)` to create a new message.
 */
export const GetDashboardResponseSchema: GenMessage<GetDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 4);

/**
 * @generated from message chalk.server.v1.ListDashboardsRequest
 */
export type ListDashboardsRequest = Message<"chalk.server.v1.ListDashboardsRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional google.protobuf.FieldMask read_mask = 3;
   */
  readMask?: FieldMask;

  /**
   * Case-insensitive substring match on dashboard name, applied before pagination.
   *
   * @generated from field: optional string search = 4 [deprecated = true];
   * @deprecated
   */
  search?: string;

  /**
   * Positive owner filter. An empty list matches all owners.
   *
   * @generated from field: repeated string created_by = 5 [deprecated = true];
   * @deprecated
   */
  createdBy: string[];

  /**
   * @generated from field: optional chalk.server.v1.DashboardSortColumn sort_column = 6;
   */
  sortColumn?: DashboardSortColumn;

  /**
   * @generated from field: optional chalk.server.v1.DashboardSortOrder sort_order = 7;
   */
  sortOrder?: DashboardSortOrder;

  /**
   * @generated from field: chalk.server.v1.ListDashboardsFilters filters = 9;
   */
  filters?: ListDashboardsFilters;
};

/**
 * Describes the message chalk.server.v1.ListDashboardsRequest.
 * Use `create(ListDashboardsRequestSchema)` to create a new message.
 */
export const ListDashboardsRequestSchema: GenMessage<ListDashboardsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 5);

/**
 * @generated from message chalk.server.v1.ListDashboardsFilters
 */
export type ListDashboardsFilters = Message<"chalk.server.v1.ListDashboardsFilters"> & {
  /**
   * When true, only dashboards favorited by the requesting user are returned.
   *
   * @generated from field: optional bool favorites_only = 1;
   */
  favoritesOnly?: boolean;

  /**
   * Case-insensitive substring match on dashboard name, applied before pagination.
   *
   * @generated from field: optional string search = 2;
   */
  search?: string;

  /**
   * An empty list matches all owners.
   *
   * @generated from field: repeated string created_by = 3;
   */
  createdBy: string[];
};

/**
 * Describes the message chalk.server.v1.ListDashboardsFilters.
 * Use `create(ListDashboardsFiltersSchema)` to create a new message.
 */
export const ListDashboardsFiltersSchema: GenMessage<ListDashboardsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 6);

/**
 * @generated from message chalk.server.v1.ListDashboardsResponse
 */
export type ListDashboardsResponse = Message<"chalk.server.v1.ListDashboardsResponse"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.Dashboard dashboards = 1;
   */
  dashboards: Dashboard[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.server.v1.ListDashboardsResponse.
 * Use `create(ListDashboardsResponseSchema)` to create a new message.
 */
export const ListDashboardsResponseSchema: GenMessage<ListDashboardsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 7);

/**
 * @generated from message chalk.server.v1.UpdateDashboardRequest
 */
export type UpdateDashboardRequest = Message<"chalk.server.v1.UpdateDashboardRequest"> & {
  /**
   * `dashboard.id` identifies the target. `update_mask` governs the artifact only and its paths are
   * rooted at `dashboard` — `name`, `description`, and/or `widgets` (`widgets` is a full
   * replacement; `description` is cleared by masking it while leaving it unset). `controls`
   * is replace-if-present: set it to overwrite the saved controls, omit it to leave them unchanged
   *
   * @generated from field: chalk.artifacts.v1.Dashboard dashboard = 1;
   */
  dashboard?: Dashboard;

  /**
   * @generated from field: optional chalk.server.v1.DashboardControls controls = 2;
   */
  controls?: DashboardControls;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message chalk.server.v1.UpdateDashboardRequest.
 * Use `create(UpdateDashboardRequestSchema)` to create a new message.
 */
export const UpdateDashboardRequestSchema: GenMessage<UpdateDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 8);

/**
 * @generated from message chalk.server.v1.UpdateDashboardResponse
 */
export type UpdateDashboardResponse = Message<"chalk.server.v1.UpdateDashboardResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.Dashboard dashboard = 1;
   */
  dashboard?: Dashboard;

  /**
   * @generated from field: chalk.server.v1.DashboardControls controls = 2;
   */
  controls?: DashboardControls;

  /**
   * @generated from field: chalk.artifacts.v1.ContentSharing sharing = 3;
   */
  sharing?: ContentSharing;
};

/**
 * Describes the message chalk.server.v1.UpdateDashboardResponse.
 * Use `create(UpdateDashboardResponseSchema)` to create a new message.
 */
export const UpdateDashboardResponseSchema: GenMessage<UpdateDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 9);

/**
 * @generated from message chalk.server.v1.UpdateDashboardSharingRequest
 */
export type UpdateDashboardSharingRequest = Message<"chalk.server.v1.UpdateDashboardSharingRequest"> & {
  /**
   * @generated from field: string dashboard_id = 1;
   */
  dashboardId: string;

  /**
   * Omit to leave unchanged. Switching to ENVIRONMENT drops every grant.
   *
   * @generated from field: optional chalk.artifacts.v1.ContentVisibility visibility = 2;
   */
  visibility?: ContentVisibility;

  /**
   * Replace-if-present, like `controls` on UpdateDashboard; omit to leave grants alone.
   *
   * @generated from field: chalk.artifacts.v1.ContentGrantList grants = 3;
   */
  grants?: ContentGrantList;
};

/**
 * Describes the message chalk.server.v1.UpdateDashboardSharingRequest.
 * Use `create(UpdateDashboardSharingRequestSchema)` to create a new message.
 */
export const UpdateDashboardSharingRequestSchema: GenMessage<UpdateDashboardSharingRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 10);

/**
 * @generated from message chalk.server.v1.UpdateDashboardSharingResponse
 */
export type UpdateDashboardSharingResponse = Message<"chalk.server.v1.UpdateDashboardSharingResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.ContentSharing sharing = 1;
   */
  sharing?: ContentSharing;
};

/**
 * Describes the message chalk.server.v1.UpdateDashboardSharingResponse.
 * Use `create(UpdateDashboardSharingResponseSchema)` to create a new message.
 */
export const UpdateDashboardSharingResponseSchema: GenMessage<UpdateDashboardSharingResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 11);

/**
 * @generated from message chalk.server.v1.DeleteDashboardRequest
 */
export type DeleteDashboardRequest = Message<"chalk.server.v1.DeleteDashboardRequest"> & {
  /**
   * @generated from field: string dashboard_id = 1;
   */
  dashboardId: string;
};

/**
 * Describes the message chalk.server.v1.DeleteDashboardRequest.
 * Use `create(DeleteDashboardRequestSchema)` to create a new message.
 */
export const DeleteDashboardRequestSchema: GenMessage<DeleteDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 12);

/**
 * @generated from message chalk.server.v1.DeleteDashboardResponse
 */
export type DeleteDashboardResponse = Message<"chalk.server.v1.DeleteDashboardResponse"> & {
};

/**
 * Describes the message chalk.server.v1.DeleteDashboardResponse.
 * Use `create(DeleteDashboardResponseSchema)` to create a new message.
 */
export const DeleteDashboardResponseSchema: GenMessage<DeleteDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 13);

/**
 * @generated from message chalk.server.v1.ExportDashboardRequest
 */
export type ExportDashboardRequest = Message<"chalk.server.v1.ExportDashboardRequest"> & {
  /**
   * @generated from field: string dashboard_id = 1;
   */
  dashboardId: string;

  /**
   * Include saved dashboard and widget IDs for editing. Omitted by default for portable exports.
   *
   * @generated from field: bool include_ids = 2;
   */
  includeIds: boolean;
};

/**
 * Describes the message chalk.server.v1.ExportDashboardRequest.
 * Use `create(ExportDashboardRequestSchema)` to create a new message.
 */
export const ExportDashboardRequestSchema: GenMessage<ExportDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 14);

/**
 * @generated from message chalk.server.v1.ExportDashboardResponse
 */
export type ExportDashboardResponse = Message<"chalk.server.v1.ExportDashboardResponse"> & {
  /**
   * The dashboard in the versioned public dashboard JSON format, pretty-printed. Server-assigned
   * fields are omitted by default for portability. include_ids adds dashboard and widget IDs.
   *
   * @generated from field: string dashboard_json_string = 1;
   */
  dashboardJsonString: string;
};

/**
 * Describes the message chalk.server.v1.ExportDashboardResponse.
 * Use `create(ExportDashboardResponseSchema)` to create a new message.
 */
export const ExportDashboardResponseSchema: GenMessage<ExportDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 15);

/**
 * @generated from message chalk.server.v1.ImportDashboardRequest
 */
export type ImportDashboardRequest = Message<"chalk.server.v1.ImportDashboardRequest"> & {
  /**
   * A dashboard in the versioned public dashboard JSON format, as produced by ExportDashboard.
   *
   * @generated from field: string dashboard_json_string = 1;
   */
  dashboardJsonString: string;

  /**
   * Optional name override, e.g. to import as a copy under a new name.
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Parse and validate only: nothing is written, and `dashboard` carries the would-be result.
   *
   * @generated from field: optional bool dry_run = 3;
   */
  dryRun?: boolean;

  /**
   * The new dashboard's visibility; omit for ENVIRONMENT. The JSON never carries sharing, and grants never copy.
   *
   * @generated from field: optional chalk.artifacts.v1.ContentVisibility visibility = 4;
   */
  visibility?: ContentVisibility;
};

/**
 * Describes the message chalk.server.v1.ImportDashboardRequest.
 * Use `create(ImportDashboardRequestSchema)` to create a new message.
 */
export const ImportDashboardRequestSchema: GenMessage<ImportDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 16);

/**
 * @generated from message chalk.server.v1.ImportDashboardResponse
 */
export type ImportDashboardResponse = Message<"chalk.server.v1.ImportDashboardResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.Dashboard dashboard = 1;
   */
  dashboard?: Dashboard;
};

/**
 * Describes the message chalk.server.v1.ImportDashboardResponse.
 * Use `create(ImportDashboardResponseSchema)` to create a new message.
 */
export const ImportDashboardResponseSchema: GenMessage<ImportDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 17);

/**
 * Returns the saved override for the requested contextual dashboard. An unset dashboard means the
 * environment still uses that location's frontend-defined default.
 *
 * @generated from message chalk.server.v1.GetContextualDashboardRequest
 */
export type GetContextualDashboardRequest = Message<"chalk.server.v1.GetContextualDashboardRequest"> & {
  /**
   * @generated from field: chalk.server.v1.ContextualDashboardLocation location = 1;
   */
  location: ContextualDashboardLocation;
};

/**
 * Describes the message chalk.server.v1.GetContextualDashboardRequest.
 * Use `create(GetContextualDashboardRequestSchema)` to create a new message.
 */
export const GetContextualDashboardRequestSchema: GenMessage<GetContextualDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 18);

/**
 * @generated from message chalk.server.v1.GetContextualDashboardResponse
 */
export type GetContextualDashboardResponse = Message<"chalk.server.v1.GetContextualDashboardResponse"> & {
  /**
   * @generated from field: optional chalk.artifacts.v1.Dashboard dashboard = 1;
   */
  dashboard?: Dashboard;
};

/**
 * Describes the message chalk.server.v1.GetContextualDashboardResponse.
 * Use `create(GetContextualDashboardResponseSchema)` to create a new message.
 */
export const GetContextualDashboardResponseSchema: GenMessage<GetContextualDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 19);

/**
 * Full replacement of a contextual dashboard's customized widgets. The first call creates the
 * environment's override for that location; later calls replace it.
 *
 * @generated from message chalk.server.v1.UpsertContextualDashboardRequest
 */
export type UpsertContextualDashboardRequest = Message<"chalk.server.v1.UpsertContextualDashboardRequest"> & {
  /**
   * @generated from field: chalk.server.v1.ContextualDashboardLocation location = 1;
   */
  location: ContextualDashboardLocation;

  /**
   * @generated from field: repeated chalk.artifacts.v1.DashboardWidget widgets = 2;
   */
  widgets: DashboardWidget[];
};

/**
 * Describes the message chalk.server.v1.UpsertContextualDashboardRequest.
 * Use `create(UpsertContextualDashboardRequestSchema)` to create a new message.
 */
export const UpsertContextualDashboardRequestSchema: GenMessage<UpsertContextualDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 20);

/**
 * @generated from message chalk.server.v1.UpsertContextualDashboardResponse
 */
export type UpsertContextualDashboardResponse = Message<"chalk.server.v1.UpsertContextualDashboardResponse"> & {
  /**
   * @generated from field: chalk.artifacts.v1.Dashboard dashboard = 1;
   */
  dashboard?: Dashboard;
};

/**
 * Describes the message chalk.server.v1.UpsertContextualDashboardResponse.
 * Use `create(UpsertContextualDashboardResponseSchema)` to create a new message.
 */
export const UpsertContextualDashboardResponseSchema: GenMessage<UpsertContextualDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 21);

/**
 * Removes the customized override so the requested location's code-defined default becomes
 * effective again.
 *
 * @generated from message chalk.server.v1.ResetContextualDashboardRequest
 */
export type ResetContextualDashboardRequest = Message<"chalk.server.v1.ResetContextualDashboardRequest"> & {
  /**
   * @generated from field: chalk.server.v1.ContextualDashboardLocation location = 1;
   */
  location: ContextualDashboardLocation;
};

/**
 * Describes the message chalk.server.v1.ResetContextualDashboardRequest.
 * Use `create(ResetContextualDashboardRequestSchema)` to create a new message.
 */
export const ResetContextualDashboardRequestSchema: GenMessage<ResetContextualDashboardRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 22);

/**
 * @generated from message chalk.server.v1.ResetContextualDashboardResponse
 */
export type ResetContextualDashboardResponse = Message<"chalk.server.v1.ResetContextualDashboardResponse"> & {
};

/**
 * Describes the message chalk.server.v1.ResetContextualDashboardResponse.
 * Use `create(ResetContextualDashboardResponseSchema)` to create a new message.
 */
export const ResetContextualDashboardResponseSchema: GenMessage<ResetContextualDashboardResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dashboard_service, 23);

/**
 * A chart annotation/overlay that can be toggled on a dashboard's charts.
 *
 * @generated from enum chalk.server.v1.DashboardAnnotation
 */
export enum DashboardAnnotation {
  /**
   * @generated from enum value: DASHBOARD_ANNOTATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DASHBOARD_ANNOTATION_INCIDENT_MARKERS = 1;
   */
  INCIDENT_MARKERS = 1,

  /**
   * @generated from enum value: DASHBOARD_ANNOTATION_INCIDENT_RANGES = 2;
   */
  INCIDENT_RANGES = 2,

  /**
   * @generated from enum value: DASHBOARD_ANNOTATION_DEPLOYMENT_MARKERS = 3;
   */
  DEPLOYMENT_MARKERS = 3,
}

/**
 * Describes the enum chalk.server.v1.DashboardAnnotation.
 */
export const DashboardAnnotationSchema: GenEnum<DashboardAnnotation> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_dashboard_service, 0);

/**
 * @generated from enum chalk.server.v1.DashboardSortColumn
 */
export enum DashboardSortColumn {
  /**
   * @generated from enum value: DASHBOARD_SORT_COLUMN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DASHBOARD_SORT_COLUMN_NAME = 1;
   */
  NAME = 1,

  /**
   * @generated from enum value: DASHBOARD_SORT_COLUMN_CREATED_AT = 2;
   */
  CREATED_AT = 2,

  /**
   * @generated from enum value: DASHBOARD_SORT_COLUMN_UPDATED_AT = 3;
   */
  UPDATED_AT = 3,
}

/**
 * Describes the enum chalk.server.v1.DashboardSortColumn.
 */
export const DashboardSortColumnSchema: GenEnum<DashboardSortColumn> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_dashboard_service, 1);

/**
 * @generated from enum chalk.server.v1.DashboardSortOrder
 */
export enum DashboardSortOrder {
  /**
   * @generated from enum value: DASHBOARD_SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DASHBOARD_SORT_ORDER_DESC = 1;
   */
  DESC = 1,

  /**
   * @generated from enum value: DASHBOARD_SORT_ORDER_ASC = 2;
   */
  ASC = 2,
}

/**
 * Describes the enum chalk.server.v1.DashboardSortOrder.
 */
export const DashboardSortOrderSchema: GenEnum<DashboardSortOrder> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_dashboard_service, 2);

/**
 * A product surface with an environment-wide, admin-managed dashboard default. Each location maps
 * to its own owned dashboard; adding a location extends this API without adding another RPC family.
 *
 * @generated from enum chalk.server.v1.ContextualDashboardLocation
 */
export enum ContextualDashboardLocation {
  /**
   * @generated from enum value: CONTEXTUAL_DASHBOARD_LOCATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTEXTUAL_DASHBOARD_LOCATION_HOME = 1;
   */
  HOME = 1,
}

/**
 * Describes the enum chalk.server.v1.ContextualDashboardLocation.
 */
export const ContextualDashboardLocationSchema: GenEnum<ContextualDashboardLocation> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_dashboard_service, 3);

/**
 * @generated from service chalk.server.v1.DashboardService
 */
export const DashboardService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.DashboardService.CreateDashboard
   */
  createDashboard: {
    methodKind: "unary";
    input: typeof CreateDashboardRequestSchema;
    output: typeof CreateDashboardResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.GetDashboard
   */
  getDashboard: {
    methodKind: "unary";
    input: typeof GetDashboardRequestSchema;
    output: typeof GetDashboardResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.ListDashboards
   */
  listDashboards: {
    methodKind: "unary";
    input: typeof ListDashboardsRequestSchema;
    output: typeof ListDashboardsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.UpdateDashboard
   */
  updateDashboard: {
    methodKind: "unary";
    input: typeof UpdateDashboardRequestSchema;
    output: typeof UpdateDashboardResponseSchema;
  },
  /**
   * Owner-only, enforced in the handler; the annotation is just the coarse gate.
   *
   * @generated from rpc chalk.server.v1.DashboardService.UpdateDashboardSharing
   */
  updateDashboardSharing: {
    methodKind: "unary";
    input: typeof UpdateDashboardSharingRequestSchema;
    output: typeof UpdateDashboardSharingResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.DeleteDashboard
   */
  deleteDashboard: {
    methodKind: "unary";
    input: typeof DeleteDashboardRequestSchema;
    output: typeof DeleteDashboardResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.ExportDashboard
   */
  exportDashboard: {
    methodKind: "unary";
    input: typeof ExportDashboardRequestSchema;
    output: typeof ExportDashboardResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.ImportDashboard
   */
  importDashboard: {
    methodKind: "unary";
    input: typeof ImportDashboardRequestSchema;
    output: typeof ImportDashboardResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.GetContextualDashboard
   */
  getContextualDashboard: {
    methodKind: "unary";
    input: typeof GetContextualDashboardRequestSchema;
    output: typeof GetContextualDashboardResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.UpsertContextualDashboard
   */
  upsertContextualDashboard: {
    methodKind: "unary";
    input: typeof UpsertContextualDashboardRequestSchema;
    output: typeof UpsertContextualDashboardResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DashboardService.ResetContextualDashboard
   */
  resetContextualDashboard: {
    methodKind: "unary";
    input: typeof ResetContextualDashboardRequestSchema;
    output: typeof ResetContextualDashboardResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_dashboard_service, 0);

